export const getPathForUrl = (url: string): string => {
  const indexQueryString = url.indexOf('?');
  if (indexQueryString > 0) {
    return url.substring(0, indexQueryString);
  }

  return url;
};
